// Text logo: brand circle behind the first letter, overline across "ar"
const NavImage = () => {
  return (
    <span className="brand-logo" aria-label="Sara777" role="img">
      <span className="brand-logo-dot" aria-hidden="true" />
      <span className="brand-logo-text" aria-hidden="true">S<span className="brand-logo-bar">ar</span>a777</span>
    </span>
  );
};

export default NavImage;
